/**
 * 定义用户基本和操作的仓库
 */
import Vue from "vue";
import { CREATE_HOUSE_STEP1_DATA } from "./mutaion-types";

const house = {
  state: {
    step1Data: null
  },

  mutations: {
    Set_Step1_Data: (state, obj) => {
      state.step1Data = obj;
    }
  },

  actions: {
    SetStep1Data({ commit }, data) {
      console.log("========================");
      console.log(data);
      return new Promise(resolve => {
        commit("Set_Step1_Data", data);
        resolve();
      });
    }
  }
};

export default house;
